import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedId } from "../../../../core/data/redux/commonSlice";
import { all_routes } from "../../../router/all_routes";
import ActionsDropdown from "../../../../core/common/crmComponents/ActionsDropdown";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import { setFilterModel } from "../../../../core/data/redux/filterSlice";

const CompanyList = ({ companiesData }) => {
  const route = all_routes;
  const dispatch = useDispatch();
  const filterModel = useSelector((state) => state.filter.filterModel);

  // Columns definition for the DataGrid
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.4,
      renderCell: (params) => (
        <ActionsDropdown
          params={params}
          path={route.companyDetails}
          module={MODULES.COMPANIES}
        />
      ),
      sortable: false,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <Link
          className="text-decoration-underline text-capitalize"
          to={route.companyDetails.replace(":id", params?.row?._id)}
          // onClick={() => dispatch(setSelectedId(params.row._id))}
        >
          {params.row.name}
        </Link>
      ),
    },
    { field: "code", headerName: "Code", flex: 0.5, sortable: true },
    { field: "mobile", headerName: "Phone", flex: 1, sortable: true },
    { field: "email", headerName: "Email", flex: 1, sortable: true },
    { field: "website", headerName: "Website", flex: 1, sortable: true },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      sortable: true,
      renderCell: (params) => (
        <span
          className={`badge badge-pill badge-status ${
            params.row.status === "active" ? "bg-success" : "bg-danger"
          }`}
        >
          {params.row.status}
        </span>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      {/* DataGrid Table */}
      <DataGrid
        rows={companiesData}
        columns={columns.map((column) => ({
          ...column,
          headerClassName: "bg-light-200",
        }))}
        getRowId={(row) => row._id}
        autoHeight
        hideFooter
        onStateChange={(state) => {
          const filteredRowIds = Object.entries(state.filter.filteredRowsLookup)
            .filter(([_, isVisible]) => isVisible === true)
            .map(([rowId]) => rowId); // Keep IDs as strings

          // Filter companiesData based on these IDs
          const filteredData = companiesData?.filter((row) =>
            filteredRowIds.includes(row?._id)
          );
          // Pass the filtered data to the parent
          // setFilteredData(filteredData);
        }}
        sx={{
          "& .sticky-column": {
            position: "sticky",
            right: 0,
            background: "white", // Prevents content from hiding under it
            zIndex: 100, // Keeps it on top
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "white",
            position: "sticky",
            top: 0,
            zIndex: 110,
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => dispatch(setFilterModel(newModel))}
        slots={{
          toolbar: GridToolbar, // Enable filter toolbar above the grid
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true }, // Hide Print Button
            csvOptions: { disableToolbarButton: true }, // Hide CSV Export
          },
        }}
      />
    </div>
  );
};

export default CompanyList;
